var render, staticRenderFns
import script from "./AxFormGroup.vue?vue&type=script&lang=ts&"
export * from "./AxFormGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AxFormGroup.vue?vue&type=style&index=0&id=74b61066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b61066",
  null
  
)

export default component.exports